<template>
  <div>
    <div class="commandes__produits commandes__ligne--border-width"
         :class="{ 'card-article': !regroupement }">
      <div class="commandes__commentaire-regroupement">
        <div class="padding" v-if="!regroupement">
          <div class="commandes__ligne-selecteurs" style='--margin: 15px 0 0 0;'>
            <b-icon class="drag" icon="drag"
                    :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
            </b-icon>
            <b-checkbox v-model="ligneCommande.selected">
            </b-checkbox>
          </div>
        </div>
        <div class="rechercheCommentaire">
          <b-field :label="isFirstLigne($t('commentaire.ligneVente.commentaire'))"
                   custom-class="is-size-7 is-marginless has-text-link ellipsis">
            <b-autocomplete v-model="ligneCommande.search"
                            :data="dataAutoCompleteComment" field="libelle"
                            @select="commentaire => selectCommentaire(commentaire)"
                            @input="getCommentData"
                            @focus="getCommentData"
                            open-on-focus
                            :placeholder="$t('commentaire.actions.search')">
              <template slot="header">
                <a @click="checkPermissions(permsCommentaire.maj)
                ? openPopUpAjoutEditCommentaire = true: showPopUp()"
                   class="lien" :class="{ 'text-access-no-permission' :
                    !checkPermissions(permsCommentaire.maj)}">
                  <span> {{$t('commentaire.actions.add')}} </span>
                </a>
              </template>
              <template slot="empty"> {{$t('commentaire.actions.noResult')}} </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="libelle pdl-10px">
          <b-field :label="isFirstLigne($t('commentaire.ligneVente.libelle'))"
                   custom-class="is-size-7 is-marginless has-text-link ellipsis">
            <b-input v-model="ligneCommande.libelle" type="textarea" :rows="nbLignesLibelle">
            </b-input>
          </b-field>
        </div>
        <div class="commandes__fin-ligne"
             :class="{ 'mgt-7px' : isFirstLigne($t('detail.article.TauxTva')) === null}">
          <div></div>
          <div></div>
          <a @click="supprimerProduit()">
            <b-icon
              icon="delete-forever"
              type="is-danger">
            </b-icon>
          </a>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpAjoutEditCommentaire"
             has-modal-card
             class="modal">
      <pop-up-add-edit-commmentaire
        @reloadCommentaire="selectCommentaire">
      </pop-up-add-edit-commmentaire>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { COMMENTAIRE } from '@/configuration/general/permissionsParametrageConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import popUpAddEditCommmentaire from '@/components/parametrage/commentaire/p_addEditCommentaire';
import gestionType from '@/services/general/gestionType';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'DevisCommandesEditLigneCommentaire',
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    regroupement: {
      type: Boolean,
      required: false,
      default: false,
    },
    indexLigne: {
      type: Number,
      required: false,
    },
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      dataAutoCompleteComment: [],
      openPopUpAjoutEditCommentaire: false,
      permsCommentaire: COMMENTAIRE,
    };
  },
  components: {
    popUpAddEditCommmentaire,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    commentaires() {
      return this.parametre(PARAMETRES_KEYS.commentaire);
    },
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    typeLibelle() {
      return gestionType(this.ligneCommande.libelle, this.error);
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    supprimerProduit() {
      this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
    },
    getCommentData() {
      if (this.ligneCommande.search) {
        this.dataAutoCompleteComment = this.commentaires.filter(commentaire => {
          return commentaire.libelle.toLocaleLowerCase()
            .includes(this.ligneCommande.search.toLocaleLowerCase());
        });
      } else this.dataAutoCompleteComment = this.commentaires;
    },
    isFirstLigne(i18nTrad) {
      if (!this.regroupement || this.indexLigne === 0) return i18nTrad;
      return null;
    },
    selectCommentaire(commentaire) {
      if (!commentaire) return;
      this.ligneCommande.libelle = commentaire.message;
      this.ligneCommande.search = commentaire.libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.commentaire]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
